/**
 * DfE Get Information About Schools field labels for UI.
 * "Does not apply" ≠ non-faith — it means the field isn't used for that establishment.
 */

const NOT_APPLICABLE = /^(does\s+not\s+apply|not\s+applicable|n\/a)$/i;

export function formatSchoolPhase(phase) {
  if (!phase || NOT_APPLICABLE.test(String(phase).trim())) return null;
  return phase;
}

export function formatReligiousCharacter(value) {
  if (!value) return null;
  const v = String(value).trim();
  if (!v || NOT_APPLICABLE.test(v)) return null;
  if (/^none$/i.test(v)) return 'No religious character';
  return v;
}
